<template>

  <div>
    <!-- 标题 -->
    <h3 v-if="title">{{ title }}</h3>
    <!-- TAB目录 -->
    <Row :gutter="8" style="margin: 0px 0 0 0; width: 100%" v-if="menus && menus.length > 0">

    </Row>
    <!-- 筛选 -->
    <Row :gutter="8" style="margin: 20px 0 0 0; width: 100%" v-if="filters && filters.length > 0">
      <Form ref="formQuery1" :label-width="100" :label-position="left" :label-colon="true" :model="query" style="width: 80%;">

        <!-- <Col
                    :xxl="6"
                    :xl="4"
                    :lg="6"
                    :md="8"
                    :sm="12"
                    :xs="24"
                    style="
                    margin: 0px 10px 10px 0;
                    display: flex;
                    flex-direction: row-reverse;
                    position: absolute;
                    top:35px;
                    z-index: 10;
                    right: 20px;
                    "
                    > -->
        <div style="margin: 0px 10px 10px 0;
                    display: flex;
                    flex-direction: row-reverse;
                    position: absolute;
                    top:35px;
                    z-index: 10;
                    right: 20px;">
          <!-- 搜索框 -->
          <Button icon="ios-search" type="success" @click="searchKeyWord" style="width: 90px;">搜索
          </Button>
          <div v-for="(v, k) in filters" :key="k" style="margin-left: 15px;">

            <Input v-if="v.name == 'search'" :key="k" clearable v-model="selectLike" placeholder="请输入搜索内容"
                   style="width: 184px;align:center"></Input>
          </div>
          <!-- <template>
            <Cascader placeholder="请选择分类" style="width:184px;align:center" />
          </template> -->
          <!-- <p style="line-height: 32px;">商品分类：</p> -->
        </div>
        <!-- <div v-if="hospitaltype!='购物车'"> -->
        <!--                    <div class="shop" v-if="this.num>0">{{ this.num }}</div>-->
        <!-- <Badge :count="num" >
                        <img src="shoping.png" style="vertical-align:middle" @click="jump('shopping_list')"/>
                    </Badge>
                </div> -->

        <!-- </Col> -->


      </Form>
    </Row>

    <template v-if="hospitaltype == '订单记录' || hospitaltype == '审批记录'">
      <Row style="min-height:400px; ">
        <template>
          <Table :columns="columns" :data="commodity" style="width: 100%" stripe border></Table>
        </template>
      </Row>
    </template>


    <!--        商品列表-->
    <template>
      <Tabs style="height: 40px;" @on-click="(e) => everyType(e)">
        <TabPane label="全部分类" icon="ios-menu-outline" :name="''" :capture-focus="true"></TabPane>
        <TabPane v-for="(tab, index) in tabList" :key="index" :label="tab.commodityType" :name="tab.id">
          {{ tab.commodityType }}</TabPane>
        <!-- <TabPane label="医疗消耗品"></TabPane>
        <TabPane label="其他分类"></TabPane>
        <TabPane label="办公消耗品"></TabPane>
        <TabPane label="医疗消耗品"></TabPane>
        <TabPane label="其他分类"></TabPane> -->
      </Tabs>
    </template>
    <Row style="width: 100%"
         v-if="(commodity.length > 0 && hospitaltype == '商品列表') || (commodity.length > 0 && hospitaltype == '耗材申请')"
         gutter="10px ">
      <Col v-for="(v, i) in this.tableCols" :key="i" span="4" style="margin-top: 10px;">
        <div style="width:90%;height:400px;border: 1px solid #f5f7f9;border-radius: 8px;">
          <img :src="loadimg(v.commodityImage)"
               style="border:none; height: 70%;width: 100%;border-top-left-radius: 8px;border-top-right-radius: 8px;"
               @click="jump('Productdetails', v.id)" /><br>
          <p style="font-size:18px;color:black;margin-left: 10px;">{{ v.commodityName }}</p><br>
          <p style="color: #9ea7b4;font-size:10px;margin-left: 10px">{{ v.commodityType }}</p>
          <div>
            <p style="margin-top:10px;margin-left: 10px">{{ v.labelName }}</p>
            <Button style="float: right;margin-right:15px; margin-top: -30px;color: red;" @click="addShop(v.id)">
              <Icon type="ios-cart-outline" />
              加入购物车
            </Button>
          </div>
        </div>
      </Col>
      <!--            <div v-for="(v,i) in commodity" :key="v" >-->
      <!--                <div class="t" style="margin-left: 30px">-->
      <!--                    <img :src="v.image" style="height: 180px;width: 243px"/><br>-->
      <!--                    <span>{{ v.name }}</span><br>-->
      <!--                    <span style="color: #9ea7b4">{{ v.commodityType }}</span><br>-->
      <!--                    <span>{{ v.commodityType }}</span>-->
      <!--                    <span style="margin-left: 40px">-->
      <!--                         <img src="jian.png" style="vertical-align: middle" v-if="v.num>0" v-on:click="reduce(i)"/>-->
      <!--                        <img src="jian.png" style="vertical-align: middle" v-if="v.num==0"/>-->
      <!--                        <span style="vertical-align: middle"> {{ v.num }}</span>-->
      <!--                      <img src="jia.png" style="vertical-align: middle;margin-left: 10px" @click="add(i)"/>-->
      <!--                    </span>-->
      <!--                </div>-->
      <!--            </div>-->
    </Row>


    <div style="width:100%">
      <Row :gutter="8"
           :style="'margin:20px 0 0 0;overflow: hidden; width:100%; padding-bottom:5px;display:' + (getWindowWidth() > 480 ? 'flex' : 'block') + ';align-items:center'">
        <Col style="flex:1">
          <slot name="action">
          </slot>
        </Col>
        <Col style="flex:2.5;just-content:flex-end;">

          <Page :total="page.total" :current="page.pageNum" :page-size="page.pageSize"
                :page-size-opts="[18, 36, 72, 108, 216, 532, 1064, 2048]" show-total
                :show-elevator="getWindowWidth() > 480 ? true : false" :show-sizer="getWindowWidth() > 480 ? true : false"
                @on-change="changePage" @on-page-size-change="changePagesize"></Page>
        </Col>
      </Row>
    </div>

    <!-- 操作 -->
    <Row :gutter="8" style="margin: 20px 0 0 0; width: 100%" v-if="actions && actions.length > 0">
      <div v-for="(v, k) in actions" :key="k" style="margin-right: 10px; display: inline-flex">
        <!-- <Col span="3" :xxl="3" :xl="4" :lg="6" :md="8" :sm="12" :xs="12" v-auth="v.auth"> -->
        <Button :size="v.size || 'default'" :type="v.type || 'warning'" v-auth="v.auth" :icon="v.icon || ''"
                @click="v.onClick">{{ v.label }}
        </Button>
        <!-- </Col> -->
      </div>
    </Row>
    <!-- 表格 -->
    <!-- 审核弹框 -->
    <Modal v-model="pass.model" width="360">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="md-information-circled"></Icon>
        <span>审核</span>
      </p>
      <div>
        <Input placeholder="请输入审核意见" type="textarea" :autosize="{ minRows: 5 }" v-model="pass.content"></Input>
      </div>
      <div slot="footer">
        <Button size="large" :type="pass.status == 1 ? 'success' : 'error'" long @click="handlePass"
                :loading="pass.sloading">{{ pass.status == 1 ? "通过" : "拒绝" }}
        </Button>
      </div>
    </Modal>
    <!-- 视频播放 -->
    <!-- <div slot="footer">
            <vioder></vioder>
        </div> -->
    <Modal v-model="pass2.model2" width="830" :closable="false" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="md-information-circled"></Icon>
        <span>{{ pass2.content }}</span>
      </p>
      <div style="text-align: center">
        <video id="play" width="500" height="300" controls="controls" v-if="pass2.content == '视频介绍'"></video>
        <audio id="play" width="500" height="300" controls="controls" v-if="pass2.content == '语音介绍'"></audio>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handlePass2">播放</Button>
        <Button type="default" @click="handleCancel">取消</Button>
      </div>
    </Modal>
    <!-- 侧栏详情 -->
    <Drawer title="详情" :closable="true" width="640" v-model="drawerBox">
      <component :is="drawerName" :kv="drawerKv"></component>
    </Drawer>
    <!-- 动态组件 -->
    <component v-for="(item, index) in extRender || []" :key="index" :ref="item" :is="item"></component>
  </div>
</template>
<script>
import baseView from "./baseView.vue";
import FormAddress from "../common/form/formAddress";
import EditTable from '../common/table/editTable.vue';
export default {
  extends: baseView,
  components: {
    tableHeader: null,
    tableFooter: null,
    FormAddress,
    EditTable
  },
  data() {
    return {
      user: {},
      value: 1,
      pageData: [],
      page: {
        p: 1,
        pageSize: 18,
        total: 10,
      },
      value2: 0,
      Specification: [],
      allselect: false,
      approval: [],
      valiue2: "1",
      selectLike: '',
      hospitaltype: "",
      title: "",
      num: 0,
      table: {
        mname: "",
        key: "",
        url: {},
        output: false,
        border: true,
        stripe: true,
        header: false,
        footer: false,
        rowClassName: () => { },
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      drawerBox: false, // 侧栏详情
      drawerName: "info", // 动态渲染的组件
      drawerKv: "", // 详情主键
      pass: {
        model: false,
        sloading: false,
        kv: null,
        status: 0,
        content: "",
        modelMap: false,
      },
      pass2: {
        model2: false,
        kv: null,
        content: "",
      },
      tabList: [],
      selected: "",
      router: { add: "", edit: "" },
      actions: [],
      tactions: [],
      menu_name: "",
      menus: [],
      query: {},
      filters: [],
      currentIndex: 0, //当前所在图片下标
      timer: null, //定时轮询
      imgArr: [],
      tableCols: [],
      commodity: [],
      details: [],
      commodityimg: [],
      columns: [],
      addShopGoods: {
        commodityQuantity: 1,
        commodityId: undefined
      },
      fy: false,
    };
  },
  extRender() {
    // 动态选择组件，["xxx","bbb"]
    return null;
  },
  watch: {
    query() {
      this.$forceUpdate();
    },
    filters() {
      this.$forceUpdate();
    },
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    // 表格行样式
    this.table.rowClassName = (row, index) => {
      return this.rowClassName(row, index);
    };

  },
  mounted() {
    this.search();
    this.loadData();
    // 获取目录上的徽标
    this.getMenuBadge();
    this.startInterval(); //进入页面后启动定时轮询
  },
  methods: {

    go: function (k) {
      this.value2 = k;
      for (let i = 0; this.commodityimg.length; i++) {
        this.commodityimg[i].ys1 = true;
        this.commodityimg[i].ys2 = false;
        if (i == k) {
          this.commodityimg[k].ys1 = !this.commodityimg[k].ys1;
          this.commodityimg[k].ys2 = !this.commodityimg[k].ys2;
        }
      }
    },
    //跳转
    jump(e, id) {
      if (this.hospitaltype == "审批中心") {
        $utils.url.push({ path: "approvaldetails" });
        // }else { $utils.url.push({path: 'productdetails' });}
      }
      if (e == "返回") {
        this.$router.go(-1);
      } else {
        $utils.url.push({ name: e, query: { id: id } });
      }
    },

    search() {
      // 取消多选框，否则有残留数据
      this.selected = "";
      // this.$refs.tablelist.page.page = 1;
      // this.$refs.tablelist.init();


    },

    async searchKeyWord() {
      await $utils.api
          .load(this.table.url.selectLike + this.selectLike, {
            selectLike: this.selectLike
          }).then(resp => {
            this.tableCols = resp.rows;
          })
      this.search();
    },

    getWindowWidth() {
      return window.innerWidth
    },

    async addShop(e) {
      this.$bus.emit('addShop')
      this.addShopGoods.commodityId = e;
      let q = this.addShopGoods;
      await $utils.api.load(this.table.url.addShop, q, 'PoST').then(resp => {
        if (resp.code == 200) {
          $utils.toast.success(resp.msg);
        }
      })
    },

    async loadData() {
      try {
        await $utils.api.load(`/admin/commodity/list?pageNum=1&pageSize=18&orderByColumn=commodityTypeId&isAsc=descending`).then(res=>{
          this.tableCols = res.rows
          this.page.total = res.total
        });

      } catch (error) {

      }
    },
    getMenuBadge() {
      let that = this;
      if (this.menus) {
        // 查询徽标数
        for (let index = 0; index < this.menus.length; index++) {
          const ee = this.menus[index];
          if (ee.badge && ee.badge.scene && ee.badge.mname) {
            let q = {};
            q.scene = ee.badge.scene;
            $utils.api
                .load(ee.badge.url || ee.badge.mname, q, "get", {
                  loading: false,
                  login: false,
                  toast: false,
                  toasterror: false,
                })
                .then((res) => {
                  if (res.status && res.data) {
                    let badge = res.data[ee.badge.scene];
                    if (badge) {
                      that.menus[index].badge.count = badge;
                      that.$forceUpdate();
                    }
                  }
                  if (res.status && res.total) {
                    let badge = res.total;
                    if (badge) {
                      that.menus[index].badge.count = badge;
                      that.$forceUpdate();
                    }
                  }
                });
          }
        }
      }
    },
    //商品加减
    reduce: function (i) {
      if (this.commodity[i].num > 0) {
        this.commodity[i].num--;
        if (this.num > 0) {
          this.num--;
        }
      }
    },
    add: function (i) {
      this.commodity[i].num++;
      this.commodity[i].select = true;
      if (this.hospitaltype != "商品详情") {
        this.num = this.num + 1;
      }
    },
    //开启定时器
    startInterval() {
      // 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.currentIndex++;
        if (this.currentIndex > this.imgArr.length - 1) {
          this.currentIndex = 0;
        }
      }, 3000);
    },
    // 点击左右箭头
    clickIcon(val) {
      if (val === "down") {
        this.currentIndex++;
        if (this.currentIndex === this.imgArr.length) {
          this.currentIndex = 0;
        }
      } else {
        /* 第一种写法
          this.currentIndex--;
          if(this.currentIndex < 0){
            this.currentIndex = this.imgArr.length-1;
          } */
        // 第二种写法
        if (this.currentIndex === 0) {
          this.currentIndex = this.imgArr.length;
        }
        this.currentIndex--;
      }
    },
    // 点击控制圆点
    changeImg(index) {
      this.currentIndex = index;
    },
    //鼠标移入移出控制
    changeInterval(val) {
      if (val) {
        clearInterval(this.timer);
      } else {
        this.startInterval();
      }
    },
    everyType(e) {
      try {
        $utils.api.load(`/admin/commodity/list?commodityTypeId=` + e).then(res => {
          this.tableCols = res.rows
        })


      } catch (e) {
      }
    },
    // 通过name查询filters下标
    indexOfName(name = "", filters = []) {
      if (!name) {
        return -1;
      }
      if (!filters) {
        filters = this.filters || [];
      }
      for (let index = 0; index < this.filters.length; index++) {
        const element = this.filters[index];
        if (element && element.name == name) {
          return index;
        }
      }
      return -1;
    },
    timeDateChange(val, field) {
      this.query.begin = val[0];
      this.query.end = val[1];
    },
    // 合并行列
    handleSpan({ row, column, rowIndex, columnIndex }) {
    },
    rowClassName(row, index) {
      return "";
    },
    toAdd(e, name = "") {
      let url = this.table.router.add || this.toLine(this.table.mname) + "_add";
      if (name && name !== "" && name !== undefined) {
        url = name;
      }
      $utils.url.push({ name: url, query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row[this.table.key];
      let url = this.table.router.edit || this.toLine(this.table.mname) + "_edit";
      $utils.url.push({ name: url, query: { action: "edit", kv: kv } });
    },
    handleSelect(selected, row) {
      let ids_arr = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
      }
      this.selected = ids_arr.join(",");
    },
    handleDel(row, index) {
      let q = {}
      q.kv = row[this.table.key]
      $utils.api.load(this.table.url.del + '/' + row[this.table.key], q, 'DELETE').then((res) => {
        if (res && res.status) {
          this.ajaxData()
          // this.thisTableData.splice(index, 1)
          $utils.toast.text(res.msg)
          this.$emit('on-del', row)
          this.pageData.total-- //后加上去的
        }
      })
    },
    handleInfo(row) {
      let kv = row[this.table.key];
      // 打开详情
      this.drawerBox = true;
      this.drawerKv = kv;
    },
    handlePass() {
      let q = {};
      q.kv = this.pass.kv;
      q.status = this.pass.status;
      q.pass_content = this.pass.content;
      if (q.kv == "" || q.status == "" || q.pass_content == "") {
        return $utils.toast.error("请求数据错误");
      }
      this.$set(this.pass, "sloading", true);
      $utils.api
          .load(this.table.url.pass || this.table.mname + "Pass", q)
          .then((res) => {
            $utils.toast.text(res.message);
            if (res.status) {
              this.$set(this.pass, "model", false);
              this.$set(this.pass, "sloading", false);
              this.search();
            }
          })
          .catch((e) => {
            console.log(e);
            this.$set(this.pass, "sloading", false);
            $utils.toast.error("数据异常");
          });
    },
    // 换页
    async changePage(e) {
      try {
        await $utils.api.load(`/admin/commodity/list?pageNum=${e}&pageSize=18&orderByColumn=commodityTypeId&isAsc=descending`).then(res=>{
          this.tableCols = res.rows
        });
      } catch (error) {

      }
    },
    async changePagesize(psize) {
      try {
        await $utils.api.load(`/admin/commodity/list?pageNum=1&pageSize=${psize}&orderByColumn=commodityTypeId&isAsc=descending`).then(res=>{
          this.tableCols = res.rows
          this.pageData.pages = 1
          this.pageData.pageSize = psize
        });
      } catch (error) {

      }

    },
  },








  // 视频语音播放
  handlePass2() {
    let q = {};
    q.kv = this.pass2.kv;
    let url = this.pass2.kv;
    this.video = url;
    this.videoElem = document.getElementById("play").src = url;
    this.videoElem = document.getElementById("play").play();
    this.$set(this.pass2, "sloading", true);
  },
  handleCancel() {
    this.videoElem = document.getElementById("play").pause();
    this.pass2.model2 = false;
  },
};
</script>
<style lang="less">
.modelMap {
  position: relative;
}

#container {
  margin: 0 auto;
}

/* 清除li前面的圆点 */
li {
  list-style-type: none;
}

.showImg {
  position: relative;
  width: 100%;
  height: 180px;
  margin: 100px auto;
  overflow: hidden;
}

/* 轮播图片 */
.showImg img {
  width: 100%;
  height: 100%;
}

/* 箭头图标 */
.iconDiv {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border: 1px solid #666;
  border-radius: 15px;
  background-color: rgba(125, 125, 125, 0.2);
  line-height: 30px;
  text-align: center;
  font-size: 25px;
  cursor: pointer;
}

.iconDiv:hover {
  background-color: white;
}

.icon-left {
  left: 10px;
}

.icon-right {
  right: 10px;
}

/* 控制圆点 */
.banner-circle {
  position: absolute;
  left: calc(-45%);
  bottom: 0;
  width: 100%;
  height: 20px;
}

.banner-circle ul {
  margin: 0 50px;
  height: 100%;
  text-align: right;
}

.banner-circle ul li {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin: 0 5px;
  border-radius: 7px;
  background-color: rgba(125, 125, 125, 0.8);
  cursor: pointer;
}

.active {
  background-color: black !important;
}

.shop {
  position: absolute;
  color: white;
  font-size: 17px;
  background-color: red;
  margin-right: 280px;
  margin-top: -10px;
  min-height: 24px;
  min-width: 24px;
  line-height: 24px;
  text-align: center;
  -webkit-border-radius: 24px;
  border-radius: 24px;
}

/* 横线 */
//图片样式
.t1 {
  width: 100px;
  height: 100px;
}

.t2 {
  width: 125px;
  height: 125px;
  border: 1px solid #2d8cf0;
}
</style>
